import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(config, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.datalake/data_lake/config", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
